import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "../../styles/blogs.css";

import { Header } from "../../components/header/header";
import { PageSupport } from "../../components/utilities/page-support";
import { BlogCard } from "../../components/cards/blog.card";
import { BlogPostContext } from "../../services/blogs/blogpost.context";

export const BlogPage = () => {

    const { blogposts } = useContext(BlogPostContext);

    const [blogs, setBlogs] = useState([]);

    const navigateTo = useNavigate();

    const cleanImages = (imagesArr) => {
        const splitArr = imagesArr.split(",");
        const cleanedAr = splitArr?.map((i) => {
            i = i.replace(/]|"|\\|\[/g, "");
            return i;
        });
        const latestImag = cleanedAr?.find((el) => cleanedAr?.indexOf(el) === 0);
        return {
            imgCap: latestImag,
            images: cleanedAr
        }
    }

    function areStringsSimilarByPattern(str1, str2) {
        // Escape special regex characters in str1 to treat it as a literal pattern
        const escapedStr1 = str1.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        // Create a regex that matches the escaped string, allowing for variations (e.g., case-insensitivity)
        const regex = new RegExp(escapedStr1, 'i'); // 'i' for case-insensitive
        return regex.test(str2);
    }

    const searchByTitle = (blogsDt, inpt) => {
        const matches = blogsDt?.filter((data) => areStringsSimilarByPattern(inpt, data?.title));
        return matches;
    }

    useEffect(() => {
        setBlogs(blogposts);
    }, [blogposts])

    return (
        <div className="f-pg">
            <PageSupport />
            <Header pageTitle={"Blogs"}/>
            <div className="search-box">
                <input 
                    type="search" 
                    className="form-input"
                    onChange={(e) => setBlogs(searchByTitle(blogposts, e.target.value))} 
                    placeholder="Enter blog title to search"
                />
            </div>
            <div className="blog-summaries">
                {blogs?.map((blogpost) => (
                    <BlogCard
                        blogdata={blogpost}
                        image={cleanImages(blogpost?.images).imgCap}
                        onClick={() => navigateTo('/blogdetail', {
                            state: {
                                blogData: blogpost,
                                images: cleanImages(blogpost?.images).images
                            }
                        })}
                    />
                ))}
            </div>
        </div>
    );
}